function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:url(#GreenGradient);}.cls-2{fill:#fff;}"), React.createElement("linearGradient", {
  id: "GreenGradient",
  x1: -522.53,
  y1: 465.47,
  x2: -416.47,
  y2: 571.53,
  gradientTransform: "translate(-481 -432) rotate(-90)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#1b660f"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6cae3e"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-Simple-Storage-Service-S3");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Reference"
}, React.createElement("rect", {
  id: "Green_Gradient",
  "data-name": "Green Gradient",
  className: "cls-1",
  width: 75,
  height: 75
}), React.createElement("g", {
  id: "Icon_Test",
  "data-name": "Icon Test"
}, React.createElement("path", {
  className: "cls-2",
  d: "M61.43,40.06c-.29-1.57-2.07-2.68-3.29-3.47-.39-.25-1.46-.65-1.55-1a2.36,2.36,0,0,1,.1-.74l1-7.19c.29-2.11.57-4.22.86-6.33.26-1.94-.67-3.24-2.25-4.33-3.22-2.23-7.42-3.13-11.21-3.75a55.85,55.85,0,0,0-14.38-.47,40,40,0,0,0-12.53,3c-2.14,1-4.94,2.56-4.59,5.29,1,8.12,2.18,16.22,3.27,24.33.5,3.71,1,7.42,1.5,11.13a4.13,4.13,0,0,0,2.46,3.33c3.1,1.68,6.94,2.16,10.4,2.48A51.5,51.5,0,0,0,45,61.73c2.88-.53,8.24-1.4,8.7-5,.57-4.46,1.2-8.92,1.8-13.37L55.72,42C57.35,42.39,62,43.22,61.43,40.06ZM36.05,14.5c6,0,12.87.68,18.25,3.64.83.46,2.76,1.49,2.18,2.71S54.1,22.68,53,23.12a30.88,30.88,0,0,1-4.83,1.35,62.29,62.29,0,0,1-21.66.45,26.8,26.8,0,0,1-9.32-2.73c-.72-.41-1.91-1.15-1.58-2.13a3,3,0,0,1,1.18-1.26,20.84,20.84,0,0,1,7.2-2.91A50.35,50.35,0,0,1,36.05,14.5ZM51.73,56.65c-.15,1.17-2.08,1.75-3,2.08a29.6,29.6,0,0,1-5.88,1.32,50.72,50.72,0,0,1-13.37,0,22.24,22.24,0,0,1-8-2.17,2,2,0,0,1-1.2-1.73c-1-7.93-2.14-15.86-3.21-23.79l-1.16-8.6a23.26,23.26,0,0,0,7.3,2.56,59.62,59.62,0,0,0,8.31,1.09,64.8,64.8,0,0,0,16.39-.91,24.27,24.27,0,0,0,8.21-2.74L54,39.46a120.43,120.43,0,0,1-14.82-6,4.27,4.27,0,0,1-.61-.29c-.27-.2-.2-.1-.33-.41-.25-.57-.31-1-.84-1.47a2.25,2.25,0,1,0-1.24,4,4.12,4.12,0,0,0,1-.3c.39-.12.39-.1.8.09a126.72,126.72,0,0,0,15,6.16c.77.25.76,0,.76.64a11.49,11.49,0,0,1-.19,1.45l-.64,4.77ZM36.3,33c0,.27-.38.24-.48.07S36.3,32.62,36.3,33ZM56,40l.3-2.21c1,.57,2.7,1.43,3.15,2.57C58.47,40.76,56.92,40.23,56,40Z"
})));

var SvgAwsS3 = function SvgAwsS3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 75 75",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsS3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-S3.a2ab8769.svg";
export { ForwardRef as ReactComponent };